import React, { Component } from "react";

import { Modal, Button, Row, Col } from "antd";


class MessageDetails extends Component {
  // state = { visible: false };

  render() {
    let messageDetails
    if (this.props.message !== undefined) {
      messageDetails = (
        <div>
          <h1> Message Details </h1>
          <Row gutter={16}>
            <Col xs={3} style={{display: "block", textAlign: "end"}}><p>To:</p></Col>
            <Col xs={21} style={{display: "block", textAlign: "start"}}><p>{this.props.message.receiver}</p></Col>
            <Col xs={3} style={{display: "block", textAlign: "end"}}><p>Subject:</p></Col>
            <Col xs={21} style={{display: "block", textAlign: "start"}}><p>{this.props.message.subject}</p></Col>
            <Col xs={3} style={{display: "block", textAlign: "end"}}><p>Message:</p></Col>
            <Col xs={21} style={{display: "block", textAlign: "start"}}><p>{this.props.message.message}</p></Col>
          </Row>
        </div>
      )
    }
    return (
      <>
        <Modal
          visible={this.props.visible}
          onOk={() => {this.props.onCancel()}}
          onCancel={() => {this.props.onCancel()}}
          style={{minWidth: "70%"}}
          footer={[
            <Button onClick={() => {this.props.onCancel()}}>
              OK
            </Button>
          ]}
        >
          <div style={{justifyContent: "center", alignItems: "center"}}>
            {messageDetails}
          </div>
        </Modal>
      </>
    );
  }
}

export default MessageDetails
